__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/e8c9f79/packs/";